// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { FileFeatureSelector } from "./FileFeatureSelector";
import {
  FileFeatureSelectorFromJSON,
  FileFeatureSelectorFromJSONTyped,
  FileFeatureSelectorToJSON,
  FileFeatureSelectorToJSONTyped,
} from "./FileFeatureSelector";
import type { StandardBoundaries } from "./StandardBoundaries";
import {
  StandardBoundariesFromJSON,
  StandardBoundariesFromJSONTyped,
  StandardBoundariesToJSON,
  StandardBoundariesToJSONTyped,
} from "./StandardBoundaries";

/**
 *
 * @export
 * @interface StandardAreaInput
 */
export interface StandardAreaInput {
  /**
   *
   */
  selection: FileFeatureSelector;
  /**
   *
   */
  standardBoundary: StandardBoundaries;
}

/**
 * Check if a given object implements the StandardAreaInput interface.
 */
export function instanceOfStandardAreaInput(value: object): value is StandardAreaInput {
  if (!("selection" in value) || value["selection"] === undefined) return false;
  if (
    (!("standardBoundary" in (value as Record<string, any>)) &&
      !("standard_boundary" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["standardBoundary"] === undefined &&
      (value as Record<string, any>)["standard_boundary"] === undefined)
  )
    return false;
  return true;
}

export function StandardAreaInputFromJSON(json: any): StandardAreaInput {
  return StandardAreaInputFromJSONTyped(json, false);
}

export function StandardAreaInputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): StandardAreaInput {
  if (json == null) {
    return json;
  }
  return {
    selection: FileFeatureSelectorFromJSON(json["selection"]),
    standardBoundary: StandardBoundariesFromJSON(json["standard_boundary"]),
  };
}

export function StandardAreaInputToJSON(json: any): StandardAreaInput {
  return StandardAreaInputToJSONTyped(json, false);
}

export function StandardAreaInputToJSONTyped(
  value?: StandardAreaInput | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    selection: FileFeatureSelectorToJSON(value["selection"]),
    standard_boundary: StandardBoundariesToJSON(value["standardBoundary"]),
  };
}
